import store from "@/store";

export function _tryTranslateValueLabel(field, value) {
    let result = {
        value: value
    };
    if (field.form && field.form.type) {
        let type = field.form.type;
        let options = [];
        if (type === 'select' || type === 'selectMultiple') {
            options = field.form.options;
        } else if (type === 'entitySelect' || type === 'entitySelectMultiple') {
            options = store.state[field.form.entity].selectItems;
            if (!options || options.length === 0) {
                result.needWaitEntityQuery = true;
            }
        } else if (type === 'boolean') {
            options = [
                {value: 'true', text: '是'},
                {value: 'false', text: '否'}
            ];
        }
        if (value) {
            if (typeof value === 'string' && value.startsWith("[")) {
                try {
                    value = JSON.parse(value);
                } catch (e) {// eslint-disable-next-line no-empty
                }
            }
            if (value instanceof Array) {
                let vList = [];
                let labelList = [];
                for (let v of value) {
                    let has = false;
                    for (let o of options) {
                        if (o.value === v || o.value === v + '') {
                            vList.push(o.value);
                            labelList.push(o.text);
                            has = true;
                        }
                    }
                    if (!has) {
                        vList.push(v);
                        labelList.push(v);
                    }
                }
                if (labelList.length > 0) {
                    result.label = JSON.stringify(labelList);
                }
                result.value = vList;
            } else {
                for (let o of options) {
                    if (o.value === value || o.value === value + '') {
                        result.label = o.text;
                    }
                }
            }
        }
    }
    return result;
}
